module.exports = __webpack_public_path__ + "static/img/centerbanner2.e08201ef.jpg";